var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWorldIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 19.5C11.995 19.4999 13.9335 18.8372 15.511 17.616C17.0886 16.3948 18.2159 14.6843 18.716 12.753M10 19.5C8.005 19.4999 6.06654 18.8372 4.48897 17.616C2.91141 16.3948 1.78408 14.6843 1.284 12.753M10 19.5C12.485 19.5 14.5 15.47 14.5 10.5C14.5 5.53 12.485 1.5 10 1.5M10 19.5C7.515 19.5 5.5 15.47 5.5 10.5C5.5 5.53 7.515 1.5 10 1.5M18.716 12.753C18.901 12.033 19 11.278 19 10.5C19.0025 8.95211 18.6038 7.42999 17.843 6.082M18.716 12.753C16.0492 14.2314 13.0492 15.0048 10 15C6.838 15 3.867 14.185 1.284 12.753M1.284 12.753C1.09475 12.017 0.999327 11.26 1 10.5C1 8.895 1.42 7.387 2.157 6.082M10 1.5C11.5962 1.49933 13.1639 1.92336 14.5422 2.72856C15.9205 3.53377 17.0597 4.69117 17.843 6.082M10 1.5C8.40376 1.49933 6.83608 1.92336 5.45781 2.72856C4.07954 3.53377 2.94031 4.69117 2.157 6.082M17.843 6.082C15.6657 7.96793 12.8805 9.00414 10 9C7.002 9 4.26 7.9 2.157 6.082",
    stroke: "#313332",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWorldIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "world-icon.9df89531cc169339e214c28c8b68742d.svg";